import React from "react";
import { connect } from "react-redux";
import { Button } from "devextreme-react";
import { doGetExcel, setValidationBlocking, setNameConflictModal, openCloseModalDeleteBlocking, openCloseModalEditWeek } from "../actions";


class TooltipBody extends React.PureComponent {
  handleDownloadFile = () => {
    if (this.props.validationBlocking.quotes > 0) {
      this.props.dispatch(doGetExcel());
    } else {
      this.props.dispatch(setValidationBlocking({
        quotes: 0,
        openValidation: false,
      }));
    }
    this.props.dispatch(setNameConflictModal(false));
    if (this.props.isOpenModalDeleteBlocking === true) {
      this.props.dispatch(openCloseModalDeleteBlocking(false, null));
    }
    if (this.props.isOpenModalEditWeek === true) {
      this.props.dispatch(openCloseModalEditWeek(false, { config: {} }));
    }
  }
  render() {
    const { blocking, validationBlocking } = this.props;
    return (

      <div
        className="row"
        style={{
          display: "flex", textAlign: "center", height: 115, alignItems: "center",
        }}
      >

        {validationBlocking.quotes === 0 && (blocking.Id === 0 || blocking.Id > 0) && (
          <div>
            <div className="col-12">
              <h4> {validationBlocking.message}  </h4>
            </div>

          </div>
        )}
        {blocking.Id === 0 && validationBlocking.quotes > 0 && (
          <div>
            <div className="col-12">
              <h4> No se puede crear la apertura ya que existen <span style={{ color: "red" }} > {validationBlocking.quotes} cupos agendados </span>
              </h4>
            </div>
            <div className="col-12">
              <h4>Primero debes resolver los conflictos removiendo estos cupos para poder crear la apertura  </h4>
            </div>
          </div>

        )}
        {blocking.Id > 0 && validationBlocking.quotes > 0 && (
          <div>
            <div className="col-12">
              <h4>  No se puede editar la apertura ya que existen <span style={{ color: "red" }}> {validationBlocking.quotes} cupos agendados </span>
              </h4>
            </div>
            <div className="col-12">
              <h4>  Primero debes resolver los conflictos removiendo estos cupos para poder editar la apertura </h4>
            </div>
          </div>
        )}

        <div
          className="col-12"
          style={{
            position: "fixed",
            textAlign: "center",
            left: 0,
            right: 0,
            bottom: 20,
          }}
        >
          <Button
            onClick={this.handleDownloadFile}
            type="success"
            width={130}
            text={validationBlocking.quotes > 0 ? "Descargar Informe y volver" : "Cerrar"}
          />

        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  blocking: state.aperturasSel.blocking,
  validationBlocking: state.aperturasSel.validationBlocking,
  isOpenModalDeleteBlocking: state.aperturasSel.isOpenModalDeleteBlocking,
  isOpenModalEditWeek: state.aperturasSel.isOpenModalEditWeek,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(TooltipBody);
